import React from 'react';
import InputField from '../InputField';

const RadioField = ({ children, ...props }) => (
  <div className="RadioField">
    <InputField type="radio" {...props}>
      {children}
    </InputField>
  </div>
);

export default RadioField;
